<template>
  <table class="table table-striped border-top-0">
    <thead class="border-top-0">
      <tr>
        <th>Location</th>
        <th>Qty</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="inv in product.inventory" :key="inv.id">
        <td style="width: 300px;">
          <span v-if="inv.parent">{{ inv.parent.name }} /</span>
          {{ inv.bin.name }}
        </td>
        <td>{{ inv.qty }}</td>
      </tr>
      <tr v-if="!product.inventory || product.inventory.length == 0">
        <td colspan="2" class="text-center p-4">
          No inventory available for this product.
        </td>
      </tr>
    </tbody>              
  </table>
</template>
<script>



export default {
  name: 'inventory-tab',
  props: ['product']
}
</script>
